import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReplaceIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.replace-icon-st0{fill:currentColor;}\n    .replace-icon-st1{fill:none;stroke:currentColor;stroke-width:1.15074;stroke-linecap:round;stroke-linejoin:round;}\n"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "replace-icon-st0",
			d: "M12.2502 7.85547C12.2502 7.5377 11.9926 7.2801 11.6748 7.2801C11.357 7.2801 11.0994 7.5377 11.0994 7.85547H12.2502ZM11.6748 10.9412L11.6749 11.5166C11.9926 11.5165 12.2502 11.2589 12.2502 10.9412H11.6748ZM11.6748 7.85547H11.0994V10.9412H11.6748H12.2502V7.85547H11.6748ZM11.6748 10.9412L11.6747 10.3658L1.25674 10.3675L1.25684 10.9429L1.25693 11.5183L11.6749 11.5166L11.6748 10.9412Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "replace-icon-st0",
			d: "M1.89368 6.14258C1.89368 6.46035 2.15129 6.71795 2.46906 6.71795C2.78683 6.71795 3.04443 6.46035 3.04443 6.14258H1.89368ZM2.46906 3.05685L2.46904 2.48148C2.15128 2.48148 1.89368 2.73909 1.89368 3.05685H2.46906ZM2.46906 6.14258H3.04443V3.05685H2.46906H1.89368V6.14258H2.46906ZM2.46906 3.05685L2.46907 3.63222L12.7432 3.63191L12.7432 3.05654L12.7431 2.48116L2.46904 2.48148L2.46906 3.05685Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "replace-icon-st1",
			d: "M2.79983 8.88477L0.742676 10.9419L2.79983 12.9991"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "replace-icon-st1",
			d: "M11.2002 5.11328L13.2573 3.05613L11.2002 0.998974"
		})
	]
});
export default SvgReplaceIcon;
